/**
 * <gs-help> — the gas spring finder's help (snippets/gas-spring-help.liquid): one dialog with a
 * section per topic, opened at the topic a question beside a field names. Any button on the page
 * whose data-help-open holds the dialog's id opens it, and its data-help-topic picks the section,
 * which takes focus so it is read first. The topics in the head (data-help-go) move between
 * sections the same way, and the current one carries aria-current.
 *
 * Escape and the close button are the platform's (`<form method="dialog">`); a click on the
 * backdrop, which lands on the dialog element itself, closes it here where `closedby` is missing.
 * The calculator's opener inside closes this dialog first, in the capture phase, so the calculator
 * opens over the page and hands focus back to the force field there.
 *
 * It also stands in for the platform where it lacks invoker commands or `closedby`, for the
 * finder's number dialog (snippets/gas-spring-finder.liquid): the bundle rides with the finder.
 */
(() => {
  if (customElements.get('gs-help')) return;
  // The finder's number dialog opens and closes by invoker commands; where a browser lacks them,
  // and `closedby`, this fills in for buttons inside a finder and for its backdrop.
  const invokers = typeof HTMLButtonElement !== 'undefined' && 'commandForElement' in HTMLButtonElement.prototype;

  class GasSpringHelp extends HTMLElement {
    connectedCallback() {
      const dialog = this.closest('dialog');
      const head = this.querySelector('.gs-help__head');
      // A topic at the top, under the sticky head, rather than wherever focus lands.
      const go = (topic) => {
        const section = this.querySelector(`section[data-help-topic="${topic}"]`);
        this.querySelectorAll('[data-help-go]').forEach((x) => x.setAttribute('aria-current', x.dataset.helpGo === topic));
        if (!section) return;
        section.focus({ preventScroll: true });
        dialog.scrollTop = section.offsetTop - head.offsetHeight;
      };
      this.onClick = (e) => {
        const b = e.target.closest && e.target.closest('button');
        if (b && b.dataset.helpOpen === dialog.id) {
          dialog.showModal();
          go(b.dataset.helpTopic);
        } else if (b && this.contains(b) && b.dataset.helpGo) {
          go(b.dataset.helpGo);
        } else if (dialog.open && (e.target === dialog || (b && this.contains(b) && b.hasAttribute('data-newton-open')))) {
          dialog.close();
        } else if (b && !invokers && b.closest('.gs-finder') && b.hasAttribute('commandfor')) {
          const d = document.getElementById(b.getAttribute('commandfor'));
          if (b.getAttribute('command') === 'close') d.close();
          else if (!d.open) d.showModal();
        } else if (e.target.matches && e.target.matches('.gs-number[open]')) {
          e.target.close();
        }
      };
      document.addEventListener('click', this.onClick, true);
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onClick, true);
    }
  }
  customElements.define('gs-help', GasSpringHelp);
})();
